import { render, staticRenderFns } from "./amountColumn.vue?vue&type=template&id=df7a3d82"
import script from "./amountColumn.vue?vue&type=script&lang=js"
export * from "./amountColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports